import React from 'react';
import ConfirmationModal from '../../../Base/Components/Confirmation/ConfirmationModal';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	text: string;
}

const DENTConfirmationModal = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	text,
}: Props) => {
	return (
		<div>
			<ConfirmationModal
				title={title}
				text={text}
				isOpen={isOpen}
				onClose={onClose}>
				<Button
					onClick={onConfirm}
					title={'base.shared.confirm'}
					theme={Theme.GREEN}
				/>
			</ConfirmationModal>
		</div>
	);
};

export default DENTConfirmationModal;
